import { Field, ErrorMessage, useField } from "formik";
import { useState } from "react";
import { FaLock, FaLockOpen } from "react-icons/fa";

const InputField = ({
	name = "",
	value = "",
	label = "",
	options = [],
	type = "",
	capitalize = false,
	onChange,
	...rest
}) => {
	const [field, meta] = useField(name); // eslint-disable-line no-unused-vars

	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<div className="w-full relative text-left">
			<label htmlFor={name} className="text-black text-sm  font-bold">
				{" "}
				{label}{" "}
			</label>

			{type === "password" ? (
				<div className="relative">
					<Field
						className="border bg-transparent text-[#e73842] border-black w-full p-2 pr-8 rounded-xl focus:border-[#e73842] focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-black disabled:text-red-500"
						name={name}
						placeholder={value}
						type={showPassword ? "text" : "password"}
						onChange={(e) => {
							field.onChange(e);
							if (onChange) onChange(e);
						}}
						{...rest}
					/>
					<button
						type="button"
						onClick={togglePasswordVisibility}
						className="absolute top-0 right-0 h-full flex items-center p-2 text-gray-500"
					>
						{showPassword ? (
							<FaLockOpen className="text-[#10477d]" />
						) : (
							<FaLock className="text-[#e73842]" />
						)}
					</button>
				</div>
			) : type === "textarea" ? (
				<div className="relative">
					<Field
						as="textarea"
						rows={4}
						className="border resize-y bg-transparent text-[#e73842] border-black w-full p-2 pr-8 rounded-xl focus:border-[#e73842] focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-black disabled:text-red-500"
						name={name}
						placeholder={value}
						maxLength={10000}
						onChange={(e) => {
							field.onChange(e);
							if (onChange) onChange(e);
						}}
						{...rest}
					/>
				</div>
			) : type !== "select" && type !== "checkbox" && type !== "color" ? (
				<div className="relative">
					<Field
						className={`border bg-transparent text-[#e73842] border-black w-full p-2 pr-8 rounded-xl focus:border-[#e73842] focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-black disabled:text-red-500 ${
							capitalize ? "uppercase" : ""
						}`}
						name={name}
						placeholder={value}
						type={type}
						maxLength={type === "text" ? 150 : undefined}
						onChange={(e) => {
							field.onChange(e);
							if (onChange) onChange(e);
						}}
						{...rest}
					/>
				</div>
			) : type === "checkbox" ? (
				<div className="flex items-center ">
					<Field
						className="form-checkbox h-11 w-11 border border-black focus:border-[#e73842] focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-400"
						name={name}
						type="checkbox"
						onChange={(e) => {
							field.onChange(e);
							if (onChange) onChange(e);
						}}
						{...rest}
					/>
				</div>
			) : (
				<Field
					className="border bg-transparent text-[#e73842] border-black w-full p-2 pr-8 rounded-xl focus:border-[#e73842] focus:outline-none ring-0 disabled:cursor-not-allowed disabled:bg-black disabled:text-red-500"
					name={name}
					as="select"
					value={value}
					onChange={(e) => {
						field.onChange(e);
						if (onChange) onChange(e);
					}}
					{...rest}
				>
					<option value="" disabled>
						Selecciona una opción
					</option>
					{options.map((option) => (
						<option
							key={option.value}
							value={option.value}
							className="text-black"
						>
							{option.label}
						</option>
					))}
				</Field>
			)}
			<ErrorMessage name={name}>
				{(message) => (
					<div className="absolute right-0 text-sm text-[#e73842]">
						{message}
					</div>
				)}
			</ErrorMessage>
		</div>
	);
};

export default InputField;
